import { useEffect } from "react";
import Footer from "./components/Footer";
import Inicio from "./components/Inicio";
import Somos from "./components/quienes-somos";
import Trans from "./components/nuestros-objetivos";
import Myv from "./components/MyV.js";
import Myvc from "./components/MyVc.js";
import Services from "./components/Services.js";
import Services2 from "./components/services2.js";
import Transico from "./components/transico.js";
import Contactos from "./components/contactos.js";

import WhatsAppFloat from "./components/WhatsAppFloat.js"

import Aos from "aos";


function App() {
  useEffect(() => {
    Aos.init({duration: 3000});
  },[]);

  return (
    <>
      <div className="d-flex flex-column gap-4">
        <Inicio/>
        <Somos/>
        <Services />
        <Transico />
        <Contactos />

       
      </div>
      <Footer/>
      <WhatsAppFloat/>
    </>
  );
}

export default App;
